import { render, staticRenderFns } from "./MensajeErrorSolicitudCuenta.vue?vue&type=template&id=0b7ddc62&scoped=true"
import script from "./MensajeErrorSolicitudCuenta.vue?vue&type=script&lang=js"
export * from "./MensajeErrorSolicitudCuenta.vue?vue&type=script&lang=js"
import style0 from "./MensajeErrorSolicitudCuenta.vue?vue&type=style&index=0&id=0b7ddc62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7ddc62",
  null
  
)

export default component.exports